import { CampaignMembership } from "@/types";

type PermissionsState = {
  loading: boolean;
  memberships: CampaignMembership[];
  is_admin: boolean;
  mfa_enabled: boolean;
  mfa_required: boolean;  
}

const defaultState = {
  loading: true,
  memberships: [],
  is_admin: false,
  mfa_required: false,
  mfa_enabled: false,
};

const permissions = function (state:PermissionsState = defaultState, action:any) {

  switch (action.type) {
    case "SET_MEMBERSHIPS":
      const {memberships, profile} = action;
      return {
        ...state,
        loading: false,
        is_admin: memberships ? memberships.some(m => m.role.name === 'admin') : false,
        memberships,
        ...profile // has mfa_required and mfa_enabled
      };
    default:
      return state;
  }
};

export default permissions;
